












import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import providers from "@/lib/api";
import BasePage from "@/components/BasePage";
import SixDigitConfirmView from "@/components/SixDigitConfirmView";

@Component({
  name: "PageForgotPasswordConfirmCode",
  components: { SixDigitConfirmView, BasePage },
})
export default class PageForgotPasswordConfirmCode extends Vue {
  @Prop({ type: String, default: "" })
  public email!: string;

  @Prop({ type: Boolean, default: false })
  public readonly changePassword!: boolean;

  public loading = false;

  public token = "";

  public codeResend() {
    providers.PasswordResetProvider.start({ data: { email: this.email } });
  }

  public get nextRoute(): Location {
    if (!this.changePassword) {
      return {
        name: "loginForgotSet",
        params: { email: this.email, token: this.token },
      };
    }
    return {
      name: "changePasswordSet",
      params: { token: this.token },
    };
  }

  public async submit(code?: string) {
    if (!code) {
      alert("Enter verification code");
      return;
    }
    try {
      this.loading = true;
      let data = await providers.PasswordResetProvider.verify({ data: { code: code, email: this.email } });
      this.token = data?.token ?? "";
      if (this.token) this.$router.push(this.nextRoute);
    } finally {
      this.loading = false;
    }
  }

  public created() {
    if (!this.changePassword) return;
    providers.PasswordResetProvider.start({ data: { email: this.email } });
  }
}
